<template>
  <div class="page">
    <p class="x-title m-bottom">拍摄二代身份证正面照(头像页)</p>
    <p class="x-font-color  m-bottom">请确保信息完整，信息与注册信息一致</p>
    <div class="m-nav">
      <span>姓 名：</span>
      <span>{{USER_INFO.realName}}</span>
    </div>
    <div class="m-nav">
      <span>身份证号：</span>
      <span>{{USER_INFO.idCardNum}}</span>
    </div>
    <!--上传身份证-->
    <m-upload-no class="m-card"/>
  </div>
</template>

<script>
  import mUploadNo from "./components/m-upload-no"
  import { mapGetters,mapMutations } from 'vuex'
  export default {
    components: {mUploadNo},
    computed: {
      ...mapGetters({
        USER_INFO: 'user/userInfo'
      })
    },
    data () {
      return {
       
      }
    },
    created () {
      this.getInfo()
    },
    methods: {
      ...mapMutations({
        SET_USER_KEY: 'user/setUserKey'
      }),
      getInfo () {
        this.http.postRequest({
          url: 'app/user/getUserInfo',
          msg: {},
          success: (res) => {
            this.SET_USER_KEY({key: 'userInfo', value: res.data ? res.data : ''})
          }
        })
      },
    },
    mounted () {

    },
    filters: {
      nameFilter: (value) => {
        if (!value) return ''
        let star = '' //存放名字中间的*
        //名字是两位的就取姓名首位+*
        if(value.length <= 2){
          return value.substring(0,1)+"*"  ;
        } else {
          for (var i = 0; i < value.length - 2; i++) {
            star  = star  + '*'
          }
          return value.substring(0, 1) + star  + value.substring(value.length - 1, value.length);
        }
      },
      numFilter:(value) =>{
        if (!value) return ''
        return value.replace(/(\w{6})\w*(\w{2})/, '$1******$2')
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
  .page{
    padding: 25px 15px;
    .m-bottom{
      margin-bottom: 8px;
    }
    .m-nav{
      color: #1D232D;
      padding-top:8px;
    }
    .m-card{
      margin: 60px 15px 30px 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
</style>

